import { getItemById } from '../../selectors/items/get-item-by-id';
import { isNormalItemAvailable } from './item-price-utils';
import { isNormalItem } from './item-type-utils';
export const getAvailableParentSalesOptions = (item) => {
    return item.options.filter(option => {
        const optionItem = getItemById(option.itemId);
        if (!optionItem)
            throw new Error(`Cannot find item with ID: '${option.itemId}'.`);
        // Currently only supporting normal items as parent sales item options
        return isNormalItem(optionItem) && isNormalItemAvailable(optionItem, option.prices);
    });
};
